"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledButton = exports.JoinSkeleton = exports.JoinLabel = void 0;
var _components = require("@ori-ui/components");
var _mui = require("@ori-ui/mui");
var _presentationUtils = require("@ori/presentation-utils");
const JoinLabel = exports.JoinLabel = (0, _mui.styled)(_mui.Link, {
  shouldForwardProp: (0, _presentationUtils.shouldNotForwardProp)(['disableRipple'])
})(({
  theme
}) => ({
  color: theme.palette.text.primary,
  display: 'block',
  fontSize: '1.4rem',
  fontWeight: theme.typography.fontWeightBold,
  textDecoration: 'none',
  whiteSpace: 'nowrap',
  textTransform: 'uppercase',
  '&:hover, &:focus, &:active': {
    color: theme.palette.grey[600],
    cursor: 'pointer'
  }
}));
const JoinSkeleton = exports.JoinSkeleton = (0, _mui.styled)(_mui.Skeleton)({
  display: 'block'
});
const StyledButton = exports.StyledButton = (0, _mui.styled)(_components.Button)({
  flexShrink: 0
});
//# sourceMappingURL=styles.js.map